module.exports = __webpack_public_path__ + "img/enterprise_bg.b56a206c.png";